import { Experiments, Specs } from '../experiments';
import { renderModel } from './util/renderModel';

export const experiments = new Experiments<Specs>(renderModel.getExperiments());
